export default __webpack_public_path__ + "media/052f7a4304ba4f17114842c195dc9cb6.png";